import Character from './Character';
import StarsPopup from '../ui/StarsPopup';
import SlotMarker from './SlotMarker';
import SlotBlings from './SlotBlings';

export default class Slot extends Phaser.Group {
  constructor(game, data) {
    super(game);
    this.data = data;

    this.obj = this.game.make.image(0, 0, 'hiding_places', data.object_front);
    this.obj.scale.set(1);
    this.obj.anchor.set(0.5, 1);
    this.addChild(this.obj);
    // this.obj.alpha = 0.3;

    this.x = data.position.x;
    this.y = data.position.y;

    this.isEmpty = true;
    this.enabled = true;

    this.onFindChar = new Phaser.Signal();
  }

  getCenter(characterId) {
    const charData = this.data.characters.find((e) => e.id === characterId);
    if (charData) {
      const scale = this.data.character_scale;
      const x = this.x + charData.offset.x + this.parent.x;
      const y = this.y + charData.offset.y - 120 * scale;
      return { x: x, y: y };
    }

    return null;
  }

  getDestX() {
    if (this.data.layer === 'bg') {
      return this.x;
    }
    // for foreground slot add paralax offset
    return this.x - this.game.state.getCurrentState().location.getForegrounOffsetForX(this.x);
  }

  showMarker() {
    if (this.marker) {
      this.marker.destroy();
      this.marker = null;
    }

    // if (this.isEmpty && this.enabled) {
    if (this.enabled) {
      const charData = this.data.characters[0];
      let scale = this.data.character_scale;
      const x = charData.offset.x;
      const y = charData.offset.y - 120 * scale;

      //
      scale = Math.min(1, scale);
      this.marker = new SlotMarker(this.game, x, y);
      this.marker.scale.set(scale);
      this.addChild(this.marker);
    }
  }

  hideMarker() {
    if (this.marker) {
      this.removeChild(this.marker);
      this.marker.destroy();
      this.marker = null;
    }
  }

  showBlings() {
    const charData = this.data.characters[0];
    let scale = this.data.character_scale;
    const x = charData.offset.x;
    const y = charData.offset.y - 120 * scale;

    scale = Math.min(1, scale);
    const blings = new SlotBlings(this.game, x, y);
    blings.scale.set(scale);
    this.addChild(blings);

    //
    this.character.wiggle();
  }

  lockCharacter() {
    if (this.character) {
      this.character.lock();
    }
  }

  unlockCharacter() {
    if (this.character) {
      this.character.unlock();
    }
  }

  unlockCharacterCheckBtn() {
    if (this.character) {
      this.character.unlockCheckBtn();
    }
  }

  hideDressUpButtons(exceptionId) {
    if (this.character && this.characterId !== exceptionId) {
      this.character.hideDressUpButtons();
    }
  }

  showDressUpButtons() {
    if (this.character) {
      this.character.showDressUpButtons();
    }
  }

  addCharacter(characterId, hudSlotRef = null) {
    this.isEmpty = false;

    const charData = this.data.characters.find((e) => e.id === characterId);

    this.characterId = characterId;
    this.character = new Character(this.game, this, charData, this.data.character_scale);
    this.addChildAt(this.character, 0);

    this.character.onFindChar.add(this.handleFindChar, this);
    this.character.hudSlotRef = hudSlotRef; // assign slot reference for character

    this.rating = charData.score; // rating of hiding place
  }

  updateRating() {
    if (this.character.clothId === -1) {
      this.rating = this.character.charData.score;
    } else {
      this.rating = this.data.clothes.find((d) => d.id === this.character.clothId).score;
    }
  }

  revealCharacter() {
    // move character to front
    this.removeChild(this.character);
    this.addChild(this.character);

    this.character.reveal();
  }

  removeCharacter() {
    this.isEmpty = true;
    this.removeChild(this.character);
    this.character.destroy();
    this.character = null;
    this.characterId = null;
  }

  returnCharacter() {
    if (!this.isEmpty) {
      this.character.hudSlotRef.setStateInitial();
      this.removeCharacter();
    }
  }

  handleFindChar(characterId) {
    this.revealCharacter();
    // dispatch event
    this.onFindChar.dispatch(characterId);
  }

  getCharacterPos() {
    return {
      x: this.x + this.parent.x + this.character.x,
      y: this.y + this.character.y - this.character.height * 0.5,
    };
  }

  getCharacterToFront() {
    this.addChild(this.character);
  }

  sendCharacterBack() {
    this.addChildAt(this.character, 0);
  }

  //
  showStarsPopup() {
    const popup = new StarsPopup(this.game, this.rating + 1);
    popup.x = this.character.x;
    popup.y = this.character.y - this.character.height + this.character.character.y;
    this.addChild(popup);
  }
}
